import {  useEffect } from 'react';
const STORAGE_KEY = 'user';

const encryptData = (data) => {
    const json = JSON.stringify(data);
    const encoded = btoa(json); 
    return encoded;
};

const decryptData = (ciphertext) => {
    const decodedJson = atob(ciphertext);
    const data = JSON.parse(decodedJson);

    return data;
};

const setLogin = async (userDetail) => {
    const encrypted = encryptData(userDetail);

    localStorage.setItem(STORAGE_KEY, encrypted);
    return true;
};

const setLogout = () => {
    localStorage.removeItem(STORAGE_KEY);
};

const getUserDetail = () => {
    const encrypted = localStorage.getItem(STORAGE_KEY);
    if (!encrypted) return null;
    try {
      return decryptData(encrypted);
    } catch (e) {
      return null; // corrupted or invalid
    }
};

const updateUserDetail = (userDetail) => {
    const encrypted = encryptData(userDetail);
    localStorage.setItem(STORAGE_KEY, encrypted);
};  

const useLocalStorageListener = (callback) => {
    useEffect(() => {
    const initialValue = localStorage.getItem('user');
    callback(initialValue);

    
    const handleStorageChange = (event) => {
        if (event.key === 'user') {
            callback(event.newValue);
        }
        };

    window.addEventListener('storage', handleStorageChange);

    return () => {
        window.removeEventListener('storage', handleStorageChange);
    };

    }, [callback]);
}

export { setLogin, setLogout,updateUserDetail, getUserDetail,decryptData,useLocalStorageListener };
